import mapService from '@/services/map.js';
import fileService from '@/services/file.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		maps: [],
		map: {},
		searchParams: {
			floorId: '',
			level: '',
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_MAPS(state, maps) {
			state.maps = maps;
		},
		SET_MAP(state, map) {
			state.map = map;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getMap({ commit, dispatch }, mapId) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await mapService
				.getMap(mapId)
				.then(data => {
					commit('SET_MAP', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting map: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getMaps({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await mapService
				.getMaps(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_MAPS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getMaps');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting maps: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async createMap({ dispatch, rootGetters }, map) {
			const { ...restOfObject } = map;
			try {
				const data = await mapService.createMap(restOfObject);

				if (map.file) {
					map.mapId = data.id;
					map.customerId = rootGetters['user/getActiveCustomer']?.id || rootGetters['buildingStore/building'].customer.id;

					await fileService.saveFile(map);
				}

				dispatch('getMaps');
			} catch (error) {
				console.log('Error creating map: ');
			}
		},

		async updateMap({ dispatch, rootGetters }, map) {
			const { oldFileId, ...restOfObject } = map;

			try {
				const data = await mapService.updateMap(restOfObject);

				if (map.oldFileId) await fileService.deleteFile(oldFileId);

				if (map.file && !map.file.id) {
					map.mapId = data.id;
					map.customerId = rootGetters['user/getActiveCustomer']?.id || rootGetters['buildingStore/building'].customer.id;
					await fileService.saveFile(map);

					dispatch('fileStore/getFile', data.id, { root: true });
				}

				dispatch('getMaps');
			} catch (error) {
				console.log('Error updating map', error);
			}
		},

		async deleteMap({ dispatch }, map) {
			return await mapService
				.deleteMap(map.id)
				.then(() => {
					dispatch('getMaps');
				})
				.catch(err => {
					console.log('Error deleting map: ', err);
				});
		},

		setMap({ commit }, map) {
			commit('SET_MAP', map);
		},
		setMaps({ commit }, maps) {
			commit('SET_MAPS', maps);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		maps: state => {
			return state.maps;
		},
		dropdownMaps: state => {
			return state.dropdownMaps;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
